// Focus timeout
export const FOCUS_TIMEOUT_VALUE = 300;

// Utility constants
export const ZERO_VALUE = 0;

// Keyboard keys
export const KEY_ESCAPE = "esc";
export const KEY_Y = "y";
export const KEY_N = "n";
export const KEY_R = "r";
export const KEY_ENTER = "enter";
export const KEY_PLUS = "+";
export const KEY_SHIFT_EQUAL = "shift+=";

// CSS Classes
export const OVERLAY_CLASS =
  "fixed top-0 left-0 w-full h-dvh bg-black opacity-25 z-[8]";

export const MAIN_CONTAINER_CLASS = "relative  inline-flex gap-5 text-left text-black w-max";

export const POPUP_CONTAINER_CLASS =
  "absolute ltr:right-0 rtl:left-0 mt-10 w-max dark:bg-gray-700  shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 z-[1000]";

export const POPUP_INNER_CLASS = "flex flex-row divide-gray-100";

export const ORDERING_LIST_CLASS = "relative inline-block rounded gap-2";

export const COLUMNS_LIST_CLASS = "flex flex-col gap-4 w-max justify-between bg-gray-50 p-5 rounded dark:bg-gray-700 dark:text-white";

export const DRAG_HANDLE_CLASS = "size-5";

export const COLUMN_ITEM_CLASS = "flex gap-2 items-center mb-1 mt-1";

export const CHECKBOX_CLASS = "form-checkbox text-primary-500 h-4 w-4 cursor-pointer";

export const SORTABLE_ITEM_CLASS =
  "px-1 py-1 aria-pressed:cursor-grab aria-pressed:font-semibold";

export const TOGGLE_ALL_LABEL_CLASS = "flex items-center gap-2";

export const TOGGLE_LABEL_CLASS = "flex gap-2 items-center";

// Test IDs
export const TEST_ID_COLUMNS_CONFIG = "columns-configuration";
export const TEST_ID_LIST_ITEM = "listitem";
export const TEST_ID_TOGGLE_PREFIX = "toggle-";
export const TEST_ID_TOGGLE_ALL = "toggle-all-columns";
export const TEST_ID_ORDERING_POPUP = "ordering-popup";
export const TEST_ID_ORDERING_LIST = "ordering-list";
export const TEST_ID_RESET_ORDER = "reset-order";

// Z-index values
export const Z_INDEX_OPEN_FILTER = "z-[9]";
export const Z_INDEX_CLOSED_FILTER = "z-[2]";

// Icon SVG dimensions
export const ICON_SIZE = "size-5";

// Button sizes and types
export const BUTTON_SIZE_SM = "sm";
export const BUTTON_TYPE_CANCEL = "cancel";
